export   function header_footer_get_parameters() {
let DEFAULT_SITE ='kay'    
let availableEnv = {
    'localhost': ['localhost', 'dev1', 'dev2', 'dev3', 'dev4',
        'qa1', 'qa2', 'uat1', 'uat2', 'perf1', 'perf2',],
    'zales': ['bridal.', 'www','dev1', 'dev2', 'dev3', 'dev4',
        'qa1', 'qa2', 'uat1', 'uat2','uat3', 'perf1', 'perf2',],
    
    'kay': ['prod2','neillane','www', 'dev1', 'uat1', 'uat2','dev5','test'],
    'jared': ['prod2','bridal.','www', 'dev1','uat1', 'uat2','test'],
};
let availableSitesUrl = {
    'localhost':DEFAULT_SITE+ '.com',
    'zales': 'zales.com',
    'kay': 'kay.com',
    'jared': 'jared.com',
   
    
};


let availableSites = {
    'localhost':DEFAULT_SITE,
    'zales': 'zales',
    'kay': 'kay',
    'jared': 'jared',
    
};

let siteNames = {
    'zales': 'Zales',
    'kay': 'Kay',
    'jared': 'Jared',
};


var localhostSite =DEFAULT_SITE;

//window.currentEnv = "prod";
//window.currentSite = "kayoutlet";
window.currentEnv = "test";
window.currentSite = DEFAULT_SITE;
//console.log('availableSites.keys', Object.keys(availableSites))
var all_sites = Object.keys(availableSites);
for (let i in all_sites) {
    let val = all_sites[i];
    //console.log('val', val)
    var windowlocationhostname =window.location.hostname.toLowerCase()
    if (windowlocationhostname.includes(val)) {
        window.currentSite = availableSites[val];
        //console.log('break available sites val', val,availableSites[val])
        break;
    }
}

console.log('currentSite', window.currentSite,window.location.href);

var all_env = availableEnv[window.currentSite];
for (let i in all_env) {
    let val = all_env[i];
    //console.log('try avail env val', val, all_env[i],window.location.href)
    if (window.location.href.includes(val)) {
        window.currentEnv = val;
        //console.log('break avail env val', val)
        break;
    }
}
//if (window.currentEnv === 'personalized.')
//    window.currentEnv = 'prod';
var calcUrl = window.currentEnv;
console.log('before currentEnv', window.currentEnv,calcUrl);
//if (['zales', 'kay', 'jared'].indexOf(window.currentSite) !== -1 && calcUrl === 'naillane') {
  if (calcUrl === 'neillane') {
    console.log('changed from', window.currentEnv,calcUrl);

        calcUrl = 'www'
}
window.currentEnv = calcUrl
console.log('currentEnv', window.currentEnv);

// for localhost testing
if (['localhost'].indexOf(window.currentSite) !== -1 && calcUrl === 'localhost') {
    calcUrl = 'uat2';
    window.currentSite = localhostSite
}

window.currentSiteUrl =   'https://' + calcUrl + '.' + availableSitesUrl[window.currentSite];
console.log('currentSiteUrl', window.currentSiteUrl);
window.baseSiteUrl = window.currentSiteUrl.replace('neillane.', 'www.');
console.log('baseSiteUrl', window.baseSiteUrl);


// default ..title
switch (window.currentSite) {
    case "kay":
        document.title = "Engagement Rings, Wedding Rings, Diamonds, Charms. Jewelry from Kay Jewelers, your trusted Jewelry Store - Kay";
        break;
    case "jared":
        document.title = "Wedding Rings, Watches, Diamonds and more. Jared&reg; the Galleria of Jewelry, 5X the selection of Ordinary Jewelry Stores - Jared";
        break;
    default:
        document.title = window.currentSite.charAt(0).toUpperCase() + window.currentSite.substr(1);
        break;
}


window.siteName = siteNames[window.currentSite];

// import css
switch (window.currentSite) {
    case "localhost":
        import('./site_interfaces/'+ localhostSite +'.css');
        break;
    default:
        import('./site_interfaces/' + window.currentSite + '.css');
        break;
}
}


// WEBPACK FOOTER //
// ./src/header_footer_parameters.js